export const intersect = <T, K>(
  arr1: T[],
  arr2: K[],
  equal: (el1: T, el2: K) => boolean
) => arr1.filter(el1 => arr2.some(el2 => equal(el1, el2)))
